"use client";

import { useTranslations } from "next-intl";
import SliderForYoutube from "./SliderForYoutube";

function SocialMediaSlider() {
    const t = useTranslations();

    return (
        <section className="w-full mx-auto bg-[#f5f5f5] max-w-7xl">
            <div>
                <div className="bg-white">
                    <div className="mx-auto ">
                        <div className="mx-auto max-w-2xl text-center my-5">
                            <h2 className="sm:text-[22px] sm:leading-[44px] tracking-[0.1px] text-mainDarkPurple md:text-[32px] leading-[38px] font-bold text-center">
                                {t("socialVideoSlider_pt")}
                            </h2>
                            <h4 className="sm:text-base sm:tracking-[0.1px] mt-2 text-mainLightPurpleText text-xl text-center font-medium px-1">
                                {t("socialVideoSlider_pt_alt")}
                            </h4>
                            <p className="sm:text-base sm:tracking-[0.1px] mt-2 text-mainLightPurpleText text-xl text-center font-medium px-1">
                                {t("socialVideoSlider_pst")}
                            </p>
                        </div>
                        <div>
                            <SliderForYoutube />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default SocialMediaSlider;
